import { deriveAvatarColor, deriveInitials } from "@/lib/colors";
import type { AvatarUser } from "@/components/ui/Avatar";
import type { MemoUser } from "@/lib/types";

/**
 * A memo's participant (`MemoUser`, the wire shape) rendered as an `AvatarUser`.
 *
 * Lives here rather than inside a component so the participant EDITOR and the read-only
 * participant LIST cannot drift into showing the same person two different ways — they are
 * the two halves of one dialog, seen by different people, and the whole point is that a
 * participant sees exactly what an organiser sees, minus the ability to change it.
 */
export function memoUserToAvatar(u: MemoUser): AvatarUser {
  const name = u.display_name ?? u.username ?? "?";
  return {
    id: u.id,
    display_name: name,
    initials: deriveInitials(name),
    avatar_color: deriveAvatarColor(u.id),
    username: u.username,
    department_workspace_id: u.department_workspace_id ?? null,
    department_color: u.department_color ?? null,
  };
}
